export const PRELOADED_TEMPLATES = [
  {
    id: 'welcome-email',
    name: 'Welcome Email',
    category: 'Onboarding',
    description: 'A warm welcome email for new subscribers or users',
    thumbnail: 'welcome',
    subject: 'Welcome to {{company_name}}!',
    blocks: [
      {
        id: 'tpl-welcome-1',
        type: 'image',
        settings: {
          src: '',
          alt: 'Company Logo',
          width: '50%',
          height: 'auto',
          link: '',
          textAlign: 'center',
          padding: { top: '5%', right: '0%', bottom: '2%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent',
          borderWidth: '0px',
          borderColor: '#cccccc',
          borderRadius: '0px'
        }
      },
      {
        id: 'tpl-welcome-2',
        type: 'heading',
        settings: {
          content: 'Welcome Aboard!',
          fontSize: '28px',
          fontFamily: 'Arial, sans-serif',
          fontWeight: 'bold',
          color: '#1e293b',
          textAlign: 'center',
          lineHeight: '1.3',
          padding: { top: '4%', right: '5%', bottom: '2%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent',
          borderWidth: '0px',
          borderColor: '#cccccc',
          borderRadius: '0px'
        }
      },
      {
        id: 'tpl-welcome-3',
        type: 'text',
        settings: {
          content: '<p>Hi {{first_name}},</p><p>Thank you for joining us! We\'re thrilled to have you on board. Here\'s what you can expect from us:</p>',
          fontSize: '16px',
          fontFamily: 'Arial, sans-serif',
          fontWeight: 'normal',
          color: '#475569',
          textAlign: 'left',
          lineHeight: '1.6',
          padding: { top: '2%', right: '5%', bottom: '2%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent',
          borderWidth: '0px',
          borderColor: '#cccccc',
          borderRadius: '0px'
        }
      },
      {
        id: 'tpl-welcome-4',
        type: 'divider',
        settings: {
          width: '80%',
          height: '1px',
          color: '#e2e8f0',
          style: 'solid',
          padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
        }
      },
      {
        id: 'tpl-welcome-5',
        type: 'columns',
        settings: {
          columnCount: 3,
          gap: '2%',
          padding: { top: '2%', right: '4%', bottom: '2%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent',
          columns: [
            {
              id: 'col-0',
              blocks: [{
                id: 'tpl-welcome-col1',
                type: 'text',
                settings: {
                  content: '<p><strong>Step 1</strong></p><p>Complete your profile to personalize your experience.</p>',
                  fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569',
                  textAlign: 'center', lineHeight: '1.5',
                  padding: { top: '2%', right: '2%', bottom: '2%', left: '2%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: '#f8fafc', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px'
                }
              }],
              content: ''
            },
            {
              id: 'col-1',
              blocks: [{
                id: 'tpl-welcome-col2',
                type: 'text',
                settings: {
                  content: '<p><strong>Step 2</strong></p><p>Explore our features and discover what we offer.</p>',
                  fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569',
                  textAlign: 'center', lineHeight: '1.5',
                  padding: { top: '2%', right: '2%', bottom: '2%', left: '2%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: '#f8fafc', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px'
                }
              }],
              content: ''
            },
            {
              id: 'col-2',
              blocks: [{
                id: 'tpl-welcome-col3',
                type: 'text',
                settings: {
                  content: '<p><strong>Step 3</strong></p><p>Connect with us on social media for updates.</p>',
                  fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569',
                  textAlign: 'center', lineHeight: '1.5',
                  padding: { top: '2%', right: '2%', bottom: '2%', left: '2%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: '#f8fafc', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px'
                }
              }],
              content: ''
            }
          ]
        }
      },
      {
        id: 'tpl-welcome-6',
        type: 'button',
        settings: {
          text: 'Get Started',
          link: '#',
          fontSize: '16px',
          fontFamily: 'Arial, sans-serif',
          fontWeight: 'bold',
          color: '#ffffff',
          backgroundColor: '#6366f1',
          textAlign: 'center',
          padding: { top: '2%', right: '7%', bottom: '2%', left: '7%' },
          margin: { top: '3%', right: '0%', bottom: '3%', left: '0%' },
          borderWidth: '0px',
          borderColor: '#4f46e5',
          borderRadius: '8px',
          width: 'auto'
        }
      },
      {
        id: 'tpl-welcome-7',
        type: 'divider',
        settings: {
          width: '100%', height: '1px', color: '#e2e8f0', style: 'solid',
          padding: { top: '3%', right: '0%', bottom: '1%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
        }
      },
      {
        id: 'tpl-welcome-8',
        type: 'social',
        settings: {
          networks: [
            { name: 'facebook', url: '#', enabled: true },
            { name: 'twitter', url: '#', enabled: true },
            { name: 'instagram', url: '#', enabled: true },
            { name: 'linkedin', url: '#', enabled: true },
            { name: 'youtube', url: '', enabled: false },
            { name: 'tiktok', url: '', enabled: false },
            { name: 'pinterest', url: '', enabled: false },
            { name: 'github', url: '', enabled: false }
          ],
          iconSize: '28',
          iconSpacing: '8',
          iconStyle: 'colored',
          iconRadius: '50%',
          textAlign: 'center',
          padding: { top: '2%', right: '4%', bottom: '4%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent'
        }
      }
    ]
  },

  {
    id: 'newsletter',
    name: 'Newsletter',
    category: 'Content',
    description: 'A clean newsletter template with featured article and sections',
    thumbnail: 'newsletter',
    subject: 'Your Weekly Update - {{date}}',
    blocks: [
      {
        id: 'tpl-news-1',
        type: 'heading',
        settings: {
          content: 'Weekly Newsletter',
          fontSize: '26px', fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#1e293b',
          textAlign: 'center', lineHeight: '1.3',
          padding: { top: '5%', right: '4%', bottom: '1%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#f0f4ff', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-news-1b',
        type: 'text',
        settings: {
          content: '<p>Your curated roundup of the latest news and insights</p>',
          fontSize: '14px', fontFamily: 'Georgia, serif', fontWeight: 'normal', color: '#64748b',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '1%', right: '4%', bottom: '5%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#f0f4ff', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-news-2',
        type: 'image',
        settings: {
          src: '',
          alt: 'Featured Article', width: '100%', height: 'auto', link: '#',
          textAlign: 'center',
          padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-news-3',
        type: 'heading',
        settings: {
          content: 'Featured: The Future of Email Marketing',
          fontSize: '22px', fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#1e293b',
          textAlign: 'left', lineHeight: '1.3',
          padding: { top: '4%', right: '5%', bottom: '1%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-news-4',
        type: 'text',
        settings: {
          content: '<p>Discover the latest trends and strategies that are reshaping how businesses connect with their audience through email. From AI-powered personalization to interactive content, the landscape is evolving fast.</p>',
          fontSize: '15px', fontFamily: 'Georgia, serif', fontWeight: 'normal', color: '#475569',
          textAlign: 'left', lineHeight: '1.7',
          padding: { top: '0%', right: '5%', bottom: '2%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-news-5',
        type: 'button',
        settings: {
          text: 'Read Full Article',
          link: '#', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold',
          color: '#ffffff', backgroundColor: '#1e293b', textAlign: 'left',
          padding: { top: '2%', right: '4%', bottom: '2%', left: '4%' },
          margin: { top: '1%', right: '0%', bottom: '4%', left: '5%' },
          borderWidth: '0px', borderColor: '#0056b3', borderRadius: '6px', width: 'auto'
        }
      },
      {
        id: 'tpl-news-6',
        type: 'divider',
        settings: {
          width: '90%', height: '1px', color: '#e2e8f0', style: 'solid',
          padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
        }
      },
      {
        id: 'tpl-news-7',
        type: 'columns',
        settings: {
          columnCount: 2, gap: '3%',
          padding: { top: '2%', right: '4%', bottom: '2%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent',
          columns: [
            {
              id: 'col-0',
              blocks: [{
                id: 'tpl-news-col1',
                type: 'text',
                settings: {
                  content: '<p><strong>Quick Tip: Subject Lines</strong></p><p>Keep them under 50 characters for the best open rates. Use action words and personalization.</p>',
                  fontSize: '14px', fontFamily: 'Georgia, serif', fontWeight: 'normal', color: '#475569',
                  textAlign: 'left', lineHeight: '1.6',
                  padding: { top: '3%', right: '3%', bottom: '3%', left: '3%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: '#fef3c7', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px'
                }
              }],
              content: ''
            },
            {
              id: 'col-1',
              blocks: [{
                id: 'tpl-news-col2',
                type: 'text',
                settings: {
                  content: '<p><strong>Stat of the Week</strong></p><p>Emails with personalized subject lines are 26% more likely to be opened. Start personalizing today!</p>',
                  fontSize: '14px', fontFamily: 'Georgia, serif', fontWeight: 'normal', color: '#475569',
                  textAlign: 'left', lineHeight: '1.6',
                  padding: { top: '3%', right: '3%', bottom: '3%', left: '3%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: '#dbeafe', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px'
                }
              }],
              content: ''
            }
          ]
        }
      },
      {
        id: 'tpl-news-8',
        type: 'divider',
        settings: {
          width: '100%', height: '1px', color: '#e2e8f0', style: 'solid',
          padding: { top: '3%', right: '0%', bottom: '2%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
        }
      },
      {
        id: 'tpl-news-9',
        type: 'text',
        settings: {
          content: '<p style="text-align:center">You received this because you subscribed to our newsletter.<br/><a href="#">Unsubscribe</a> | <a href="#">View in browser</a></p>',
          fontSize: '12px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '3%', right: '4%', bottom: '5%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      }
    ]
  },

  {
    id: 'promotional',
    name: 'Promotional',
    category: 'Marketing',
    description: 'A promotional email with sale details, products, and CTA',
    thumbnail: 'promotional',
    subject: 'Special Offer Inside - Up to 50% Off!',
    blocks: [
      {
        id: 'tpl-promo-1',
        type: 'heading',
        settings: {
          content: 'FLASH SALE',
          fontSize: '36px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#ffffff',
          textAlign: 'center', lineHeight: '1.2',
          padding: { top: '7%', right: '4%', bottom: '2%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#dc2626', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-promo-2',
        type: 'text',
        settings: {
          content: '<p>Up to <strong>50% OFF</strong> everything. Limited time only!</p>',
          fontSize: '18px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#fef2f2',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '2%', right: '5%', bottom: '5%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#dc2626', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-promo-3',
        type: 'spacer',
        settings: { height: '15px', backgroundColor: 'transparent' }
      },
      {
        id: 'tpl-promo-4',
        type: 'columns',
        settings: {
          columnCount: 2, gap: '3%',
          padding: { top: '2%', right: '3%', bottom: '2%', left: '3%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent',
          columns: [
            {
              id: 'col-0',
              blocks: [{
                id: 'tpl-promo-col1',
                type: 'image',
                settings: {
                  src: '',
                  alt: 'Product 1', width: '100%', height: 'auto', link: '#',
                  textAlign: 'center',
                  padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: 'transparent', borderWidth: '1px', borderColor: '#e5e7eb', borderRadius: '8px'
                }
              }],
              content: ''
            },
            {
              id: 'col-1',
              blocks: [{
                id: 'tpl-promo-col2',
                type: 'image',
                settings: {
                  src: '',
                  alt: 'Product 2', width: '100%', height: 'auto', link: '#',
                  textAlign: 'center',
                  padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: 'transparent', borderWidth: '1px', borderColor: '#e5e7eb', borderRadius: '8px'
                }
              }],
              content: ''
            }
          ]
        }
      },
      {
        id: 'tpl-promo-5',
        type: 'text',
        settings: {
          content: '<p>Don\'t miss out on our biggest sale of the season. These deals won\'t last long!</p>',
          fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569',
          textAlign: 'center', lineHeight: '1.6',
          padding: { top: '3%', right: '5%', bottom: '1%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-promo-6',
        type: 'button',
        settings: {
          text: 'Shop Now',
          link: '#', fontSize: '18px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold',
          color: '#ffffff', backgroundColor: '#dc2626', textAlign: 'center',
          padding: { top: '3%', right: '8%', bottom: '3%', left: '8%' },
          margin: { top: '2%', right: '0%', bottom: '5%', left: '0%' },
          borderWidth: '0px', borderColor: '#b91c1c', borderRadius: '8px', width: 'auto'
        }
      },
      {
        id: 'tpl-promo-7',
        type: 'text',
        settings: {
          content: '<p>Use code <strong>FLASH50</strong> at checkout for extra savings.</p>',
          fontSize: '13px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '2%', right: '4%', bottom: '5%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#f8fafc', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      }
    ]
  },

  {
    id: 'transactional',
    name: 'Order Confirmation',
    category: 'Transactional',
    description: 'A transactional email for order confirmations',
    thumbnail: 'transactional',
    subject: 'Order Confirmed - #{{order_number}}',
    blocks: [
      {
        id: 'tpl-tx-1',
        type: 'heading',
        settings: {
          content: 'Order Confirmed!',
          fontSize: '28px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#059669',
          textAlign: 'center', lineHeight: '1.3',
          padding: { top: '5%', right: '4%', bottom: '2%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#ecfdf5', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-tx-2',
        type: 'text',
        settings: {
          content: '<p>Thank you for your order! We\'re getting it ready for you.</p>',
          fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#065f46',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '1%', right: '5%', bottom: '5%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#ecfdf5', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-tx-3',
        type: 'text',
        settings: {
          content: '<p><strong>Order Number:</strong> #12345<br/><strong>Order Date:</strong> April 14, 2026<br/><strong>Estimated Delivery:</strong> April 18-20, 2026</p>',
          fontSize: '15px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#334155',
          textAlign: 'left', lineHeight: '1.8',
          padding: { top: '4%', right: '5%', bottom: '4%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#f8fafc', borderWidth: '1px', borderColor: '#e2e8f0', borderRadius: '8px'
        }
      },
      {
        id: 'tpl-tx-4',
        type: 'spacer',
        settings: { height: '10px', backgroundColor: 'transparent' }
      },
      {
        id: 'tpl-tx-5',
        type: 'table',
        settings: {
          rows: [
            ['Item', 'Qty', 'Price'],
            ['Product Name Here', '1', '$49.99'],
            ['Another Product', '2', '$29.99'],
            ['', 'Total', '$109.97']
          ],
          showHeader: true, striped: true, tableWidth: '100%',
          headerBackgroundColor: '#f1f5f9', headerTextColor: '#1e293b',
          tableBorderColor: '#e2e8f0', cellPadding: '12px',
          fontSize: '14px', fontFamily: 'Arial, sans-serif', color: '#475569',
          padding: { top: '2%', right: '4%', bottom: '2%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
        }
      },
      {
        id: 'tpl-tx-6',
        type: 'button',
        settings: {
          text: 'Track Your Order',
          link: '#', fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold',
          color: '#ffffff', backgroundColor: '#059669', textAlign: 'center',
          padding: { top: '2%', right: '6%', bottom: '2%', left: '6%' },
          margin: { top: '3%', right: '0%', bottom: '3%', left: '0%' },
          borderWidth: '0px', borderColor: '#047857', borderRadius: '8px', width: 'auto'
        }
      },
      {
        id: 'tpl-tx-7',
        type: 'divider',
        settings: {
          width: '100%', height: '1px', color: '#e2e8f0', style: 'solid',
          padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
        }
      },
      {
        id: 'tpl-tx-8',
        type: 'text',
        settings: {
          content: '<p>Need help? Reply to this email or contact our <a href="#">support team</a>.</p>',
          fontSize: '13px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '2%', right: '4%', bottom: '5%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      }
    ]
  },

  {
    id: 'event-invite',
    name: 'Event Invite',
    category: 'Events',
    description: 'An event invitation with details and RSVP button',
    thumbnail: 'event',
    subject: 'You\'re Invited: {{event_name}}',
    blocks: [
      {
        id: 'tpl-event-1',
        type: 'image',
        settings: {
          src: '',
          alt: 'Event Banner', width: '100%', height: 'auto', link: '',
          textAlign: 'center',
          padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-event-2',
        type: 'heading',
        settings: {
          content: 'You\'re Invited!',
          fontSize: '30px', fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#4f46e5',
          textAlign: 'center', lineHeight: '1.3',
          padding: { top: '5%', right: '4%', bottom: '2%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-event-3',
        type: 'text',
        settings: {
          content: '<p>Join us for an exclusive event that you won\'t want to miss. We have an exciting lineup of speakers, workshops, and networking opportunities.</p>',
          fontSize: '16px', fontFamily: 'Georgia, serif', fontWeight: 'normal', color: '#475569',
          textAlign: 'center', lineHeight: '1.7',
          padding: { top: '1%', right: '5%', bottom: '4%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-event-4',
        type: 'columns',
        settings: {
          columnCount: 3, gap: '1%',
          padding: { top: '0%', right: '4%', bottom: '0%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: '#f5f3ff',
          columns: [
            {
              id: 'col-0',
              blocks: [{
                id: 'tpl-event-col1', type: 'text',
                settings: {
                  content: '<p><strong>Date</strong></p><p>May 15, 2026</p>',
                  fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#4f46e5',
                  textAlign: 'center', lineHeight: '1.5',
                  padding: { top: '3%', right: '2%', bottom: '3%', left: '2%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
                }
              }], content: ''
            },
            {
              id: 'col-1',
              blocks: [{
                id: 'tpl-event-col2', type: 'text',
                settings: {
                  content: '<p><strong>Time</strong></p><p>6:00 PM - 9:00 PM</p>',
                  fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#4f46e5',
                  textAlign: 'center', lineHeight: '1.5',
                  padding: { top: '3%', right: '2%', bottom: '3%', left: '2%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
                }
              }], content: ''
            },
            {
              id: 'col-2',
              blocks: [{
                id: 'tpl-event-col3', type: 'text',
                settings: {
                  content: '<p><strong>Location</strong></p><p>Convention Center</p>',
                  fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#4f46e5',
                  textAlign: 'center', lineHeight: '1.5',
                  padding: { top: '3%', right: '2%', bottom: '3%', left: '2%' },
                  margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
                  backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
                }
              }], content: ''
            }
          ]
        }
      },
      {
        id: 'tpl-event-5',
        type: 'button',
        settings: {
          text: 'RSVP Now',
          link: '#', fontSize: '18px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold',
          color: '#ffffff', backgroundColor: '#4f46e5', textAlign: 'center',
          padding: { top: '3%', right: '8%', bottom: '3%', left: '8%' },
          margin: { top: '4%', right: '0%', bottom: '5%', left: '0%' },
          borderWidth: '0px', borderColor: '#4338ca', borderRadius: '8px', width: 'auto'
        }
      },
      {
        id: 'tpl-event-6',
        type: 'text',
        settings: {
          content: '<p>Can\'t make it? <a href="#">Let us know</a> and we\'ll send you the recording.</p>',
          fontSize: '13px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '2%', right: '4%', bottom: '5%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      }
    ]
  },

  {
    id: 'simple-announcement',
    name: 'Simple Announcement',
    category: 'General',
    description: 'A minimal, clean announcement email',
    thumbnail: 'announcement',
    subject: 'Important Update from {{company_name}}',
    blocks: [
      {
        id: 'tpl-ann-1',
        type: 'spacer',
        settings: { height: '25px', backgroundColor: 'transparent' }
      },
      {
        id: 'tpl-ann-2',
        type: 'image',
        settings: {
          src: '',
          alt: 'Company Logo', width: '35%', height: 'auto', link: '',
          textAlign: 'center',
          padding: { top: '0%', right: '0%', bottom: '4%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-ann-3',
        type: 'heading',
        settings: {
          content: 'We Have Exciting News!',
          fontSize: '26px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#1e293b',
          textAlign: 'center', lineHeight: '1.3',
          padding: { top: '2%', right: '5%', bottom: '3%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-ann-4',
        type: 'text',
        settings: {
          content: '<p>We\'re excited to share some important news with you. After months of hard work, we\'re launching something that will make your experience even better.</p><p>Here\'s what\'s changing and why it matters to you...</p>',
          fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569',
          textAlign: 'left', lineHeight: '1.7',
          padding: { top: '1%', right: '5%', bottom: '3%', left: '5%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      },
      {
        id: 'tpl-ann-5',
        type: 'button',
        settings: {
          text: 'Learn More',
          link: '#', fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold',
          color: '#ffffff', backgroundColor: '#6366f1', textAlign: 'center',
          padding: { top: '2%', right: '7%', bottom: '2%', left: '7%' },
          margin: { top: '1%', right: '0%', bottom: '4%', left: '0%' },
          borderWidth: '0px', borderColor: '#4f46e5', borderRadius: '8px', width: 'auto'
        }
      },
      {
        id: 'tpl-ann-6',
        type: 'divider',
        settings: {
          width: '100%', height: '1px', color: '#e2e8f0', style: 'solid',
          padding: { top: '2%', right: '0%', bottom: '2%', left: '0%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }
        }
      },
      {
        id: 'tpl-ann-7',
        type: 'text',
        settings: {
          content: '<p>Best regards,<br/>The Team</p>',
          fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#64748b',
          textAlign: 'center', lineHeight: '1.5',
          padding: { top: '2%', right: '4%', bottom: '5%', left: '4%' },
          margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' },
          backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px'
        }
      }
    ]
  },

  // ── SaaS Product Launch ──
  {
    id: 'saas-launch',
    name: 'SaaS Product Launch',
    category: 'SaaS',
    description: 'Announce a new feature or product to your users',
    thumbnail: 'saas',
    subject: 'Introducing {{feature_name}} - Your Workflow Just Got Better',
    bodySettings: { emailWidth: 600, backgroundColor: '#0f172a', contentBackgroundColor: '#1e293b', fontFamily: 'Arial, sans-serif', contentPadding: 0, contentBorderRadius: '12px' },
    blocks: [
      { id: 'tpl-saas-1', type: 'spacer', settings: { height: '20px', backgroundColor: 'transparent' } },
      { id: 'tpl-saas-2', type: 'heading', settings: { content: '🚀 Something Big Just Launched', fontSize: '28px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#ffffff', textAlign: 'center', lineHeight: '1.3', padding: { top: '5%', right: '5%', bottom: '1%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-saas-3', type: 'text', settings: { content: '<p>We have been working hard behind the scenes, and today we are thrilled to share our latest feature that will transform how you work.</p>', fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8', textAlign: 'center', lineHeight: '1.6', padding: { top: '1%', right: '8%', bottom: '3%', left: '8%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-saas-4', type: 'image', settings: { src: '', alt: 'Product Screenshot', width: '90%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '3%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } },
      { id: 'tpl-saas-5', type: 'columns', settings: { columnCount: 3, gap: '2%', padding: { top: '2%', right: '3%', bottom: '2%', left: '3%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', columns: [
        { id: 'col-0', blocks: [{ id: 'tpl-saas-c1', type: 'text', settings: { content: '<p><strong>⚡ Fast</strong></p><p>10x faster than before with our new engine</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#cbd5e1', textAlign: 'center', lineHeight: '1.5', padding: { top: '3%', right: '3%', bottom: '3%', left: '3%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#334155', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } }] },
        { id: 'col-1', blocks: [{ id: 'tpl-saas-c2', type: 'text', settings: { content: '<p><strong>🔒 Secure</strong></p><p>Enterprise-grade security built in</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#cbd5e1', textAlign: 'center', lineHeight: '1.5', padding: { top: '3%', right: '3%', bottom: '3%', left: '3%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#334155', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } }] },
        { id: 'col-2', blocks: [{ id: 'tpl-saas-c3', type: 'text', settings: { content: '<p><strong>🎯 Smart</strong></p><p>AI-powered insights at your fingertips</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#cbd5e1', textAlign: 'center', lineHeight: '1.5', padding: { top: '3%', right: '3%', bottom: '3%', left: '3%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#334155', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } }] }
      ] } },
      { id: 'tpl-saas-6', type: 'button', settings: { text: 'Try It Now — Free', link: '#', fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#0f172a', backgroundColor: '#38bdf8', textAlign: 'center', padding: { top: '14px', right: '32px', bottom: '14px', left: '32px' }, margin: { top: '2%', right: '0%', bottom: '3%', left: '0%' }, borderWidth: '0px', borderColor: '#0056b3', borderRadius: '8px', width: 'auto' } },
      { id: 'tpl-saas-7', type: 'text', settings: { content: '<p>Questions? Reply to this email or visit our <a href="#">help center</a>.</p>', fontSize: '13px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#64748b', textAlign: 'center', lineHeight: '1.5', padding: { top: '2%', right: '5%', bottom: '4%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } }
    ]
  },

  // ── eCommerce Sale ──
  {
    id: 'ecommerce-sale',
    name: 'eCommerce Flash Sale',
    category: 'eCommerce',
    description: 'Drive urgency with a flash sale email',
    thumbnail: 'ecommerce',
    subject: '🔥 Flash Sale — Up to 50% Off Ends Tonight!',
    bodySettings: { emailWidth: 600, backgroundColor: '#fef2f2', contentBackgroundColor: '#ffffff', fontFamily: 'Arial, sans-serif', contentPadding: 0, contentBorderRadius: '0px' },
    blocks: [
      { id: 'tpl-ec-1', type: 'heading', settings: { content: '⏰ FLASH SALE', fontSize: '36px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#ffffff', textAlign: 'center', lineHeight: '1.2', padding: { top: '6%', right: '5%', bottom: '2%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#dc2626', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-ec-2', type: 'text', settings: { content: '<p style="font-size:48px; font-weight:800; margin:0;">UP TO 50% OFF</p><p>Use code: <strong>FLASH50</strong></p>', fontSize: '18px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#ffffff', textAlign: 'center', lineHeight: '1.4', padding: { top: '1%', right: '5%', bottom: '4%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#dc2626', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-ec-3', type: 'columns', settings: { columnCount: 2, gap: '3%', padding: { top: '4%', right: '3%', bottom: '2%', left: '3%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', columns: [
        { id: 'col-0', blocks: [
          { id: 'tpl-ec-c1', type: 'image', settings: { src: '', alt: 'Product 1', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '2%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#f8fafc', borderWidth: '1px', borderColor: '#e2e8f0', borderRadius: '8px' } },
          { id: 'tpl-ec-c1t', type: 'text', settings: { content: '<p><strong>Premium Headphones</strong></p><p><s>$199</s> <span style="color:#dc2626;font-weight:bold;">$99</span></p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#1e293b', textAlign: 'center', lineHeight: '1.5', padding: { top: '1%', right: '2%', bottom: '2%', left: '2%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } }
        ] },
        { id: 'col-1', blocks: [
          { id: 'tpl-ec-c2', type: 'image', settings: { src: '', alt: 'Product 2', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '2%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#f8fafc', borderWidth: '1px', borderColor: '#e2e8f0', borderRadius: '8px' } },
          { id: 'tpl-ec-c2t', type: 'text', settings: { content: '<p><strong>Smart Watch Pro</strong></p><p><s>$299</s> <span style="color:#dc2626;font-weight:bold;">$149</span></p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#1e293b', textAlign: 'center', lineHeight: '1.5', padding: { top: '1%', right: '2%', bottom: '2%', left: '2%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } }
        ] }
      ] } },
      { id: 'tpl-ec-4', type: 'button', settings: { text: 'Shop the Sale →', link: '#', fontSize: '18px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#ffffff', backgroundColor: '#dc2626', textAlign: 'center', padding: { top: '14px', right: '40px', bottom: '14px', left: '40px' }, margin: { top: '2%', right: '0%', bottom: '2%', left: '0%' }, borderWidth: '0px', borderColor: '#0056b3', borderRadius: '8px', width: 'auto' } },
      { id: 'tpl-ec-5', type: 'text', settings: { content: '<p>Sale ends tonight at 11:59 PM. Free shipping on orders over $50.</p>', fontSize: '13px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8', textAlign: 'center', lineHeight: '1.5', padding: { top: '2%', right: '5%', bottom: '4%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } }
    ]
  },

  // ── Real Estate Listing ──
  {
    id: 'real-estate',
    name: 'Real Estate Listing',
    category: 'Real Estate',
    description: 'Showcase a property listing with details',
    thumbnail: 'realestate',
    subject: 'New Listing: Stunning 3BR Home in {{neighborhood}}',
    blocks: [
      { id: 'tpl-re-1', type: 'image', settings: { src: '', alt: 'Property Hero', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-re-2', type: 'heading', settings: { content: '$485,000 — 3 Bed | 2 Bath | 1,850 sqft', fontSize: '22px', fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#1e293b', textAlign: 'center', lineHeight: '1.3', padding: { top: '4%', right: '4%', bottom: '1%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-re-3', type: 'text', settings: { content: '<p>📍 123 Oak Avenue, Westfield Heights</p>', fontSize: '15px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#64748b', textAlign: 'center', lineHeight: '1.5', padding: { top: '0%', right: '4%', bottom: '2%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-re-4', type: 'divider', settings: { width: '60%', height: '1px', color: '#e2e8f0', style: 'solid', padding: { top: '1%', right: '0%', bottom: '1%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' } } },
      { id: 'tpl-re-5', type: 'text', settings: { content: '<p>This beautifully updated home features an open floor plan, modern kitchen with granite countertops, hardwood floors throughout, and a spacious backyard perfect for entertaining. Located in a top-rated school district with easy access to shopping and dining.</p>', fontSize: '15px', fontFamily: 'Georgia, serif', fontWeight: 'normal', color: '#475569', textAlign: 'left', lineHeight: '1.7', padding: { top: '2%', right: '5%', bottom: '2%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-re-6', type: 'columns', settings: { columnCount: 3, gap: '2%', padding: { top: '2%', right: '3%', bottom: '2%', left: '3%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', columns: [
        { id: 'col-0', blocks: [{ id: 'tpl-re-c1', type: 'image', settings: { src: '', alt: 'Interior 1', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#f1f5f9', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '4px' } }] },
        { id: 'col-1', blocks: [{ id: 'tpl-re-c2', type: 'image', settings: { src: '', alt: 'Interior 2', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#f1f5f9', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '4px' } }] },
        { id: 'col-2', blocks: [{ id: 'tpl-re-c3', type: 'image', settings: { src: '', alt: 'Interior 3', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#f1f5f9', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '4px' } }] }
      ] } },
      { id: 'tpl-re-7', type: 'button', settings: { text: 'Schedule a Viewing', link: '#', fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#ffffff', backgroundColor: '#16a34a', textAlign: 'center', padding: { top: '14px', right: '32px', bottom: '14px', left: '32px' }, margin: { top: '2%', right: '0%', bottom: '2%', left: '0%' }, borderWidth: '0px', borderColor: '#0056b3', borderRadius: '8px', width: 'auto' } },
      { id: 'tpl-re-8', type: 'text', settings: { content: '<p>Jane Smith, Realtor | (555) 123-4567 | jane@realestate.com</p>', fontSize: '13px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8', textAlign: 'center', lineHeight: '1.5', padding: { top: '2%', right: '4%', bottom: '4%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } }
    ]
  },

  // ── Restaurant / Food ──
  {
    id: 'restaurant',
    name: 'Restaurant Special',
    category: 'Restaurant',
    description: 'Promote a restaurant special or new menu',
    thumbnail: 'restaurant',
    subject: '🍽️ This Week\'s Special Menu — Reserve Your Table',
    bodySettings: { emailWidth: 600, backgroundColor: '#fffbeb', contentBackgroundColor: '#ffffff', fontFamily: 'Georgia, serif', contentPadding: 0, contentBorderRadius: '0px' },
    blocks: [
      { id: 'tpl-rest-1', type: 'image', settings: { src: '', alt: 'Restaurant Header', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-rest-2', type: 'heading', settings: { content: 'Chef\'s Special This Week', fontSize: '30px', fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#78350f', textAlign: 'center', lineHeight: '1.3', padding: { top: '5%', right: '5%', bottom: '1%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-rest-3', type: 'divider', settings: { width: '20%', height: '2px', color: '#d97706', style: 'solid', padding: { top: '1%', right: '0%', bottom: '2%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' } } },
      { id: 'tpl-rest-4', type: 'text', settings: { content: '<p><strong>🥩 Grilled Wagyu Ribeye</strong> — $48<br/>Served with truffle mashed potatoes and seasonal vegetables</p><p><strong>🍝 Handmade Truffle Pasta</strong> — $32<br/>Fresh fettuccine with black truffle cream sauce</p><p><strong>🍰 Crème Brûlée</strong> — $14<br/>Classic vanilla bean with caramelized sugar</p>', fontSize: '15px', fontFamily: 'Georgia, serif', fontWeight: 'normal', color: '#44403c', textAlign: 'center', lineHeight: '1.8', padding: { top: '2%', right: '8%', bottom: '3%', left: '8%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-rest-5', type: 'button', settings: { text: 'Reserve a Table', link: '#', fontSize: '16px', fontFamily: 'Georgia, serif', fontWeight: 'bold', color: '#ffffff', backgroundColor: '#b45309', textAlign: 'center', padding: { top: '14px', right: '32px', bottom: '14px', left: '32px' }, margin: { top: '1%', right: '0%', bottom: '3%', left: '0%' }, borderWidth: '0px', borderColor: '#0056b3', borderRadius: '6px', width: 'auto' } },
      { id: 'tpl-rest-6', type: 'text', settings: { content: '<p>📍 456 Gourmet Lane, Downtown | Open Tue-Sun 5PM-11PM<br/>📞 (555) 987-6543 | reservations@therestaurant.com</p>', fontSize: '13px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#94a3b8', textAlign: 'center', lineHeight: '1.6', padding: { top: '2%', right: '5%', bottom: '5%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#fef3c7', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } }
    ]
  },

  // ── Fitness / Gym ──
  {
    id: 'fitness',
    name: 'Fitness Program',
    category: 'Fitness',
    description: 'Promote a fitness class or program',
    thumbnail: 'fitness',
    subject: '💪 New Year, New You — Join Our 30-Day Challenge',
    bodySettings: { emailWidth: 600, backgroundColor: '#1a1a2e', contentBackgroundColor: '#16213e', fontFamily: 'Arial, sans-serif', contentPadding: 0, contentBorderRadius: '8px' },
    blocks: [
      { id: 'tpl-fit-1', type: 'heading', settings: { content: '30-DAY FITNESS CHALLENGE', fontSize: '32px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#e94560', textAlign: 'center', lineHeight: '1.2', padding: { top: '6%', right: '5%', bottom: '1%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-fit-2', type: 'text', settings: { content: '<p>Transform your body and mind in just 30 days. Expert-led workouts, personalized meal plans, and a supportive community to keep you motivated.</p>', fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#a7b1c2', textAlign: 'center', lineHeight: '1.6', padding: { top: '1%', right: '6%', bottom: '3%', left: '6%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-fit-3', type: 'image', settings: { src: '', alt: 'Fitness Hero', width: '100%', height: 'auto', link: '', textAlign: 'center', padding: { top: '0%', right: '4%', bottom: '3%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } },
      { id: 'tpl-fit-4', type: 'columns', settings: { columnCount: 3, gap: '2%', padding: { top: '2%', right: '3%', bottom: '2%', left: '3%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', columns: [
        { id: 'col-0', blocks: [{ id: 'tpl-fit-c1', type: 'text', settings: { content: '<p style="font-size:28px; font-weight:800; color:#e94560; margin:0;">150+</p><p>Workouts</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#a7b1c2', textAlign: 'center', lineHeight: '1.4', padding: { top: '4%', right: '2%', bottom: '4%', left: '2%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#0f3460', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } }] },
        { id: 'col-1', blocks: [{ id: 'tpl-fit-c2', type: 'text', settings: { content: '<p style="font-size:28px; font-weight:800; color:#e94560; margin:0;">30</p><p>Meal Plans</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#a7b1c2', textAlign: 'center', lineHeight: '1.4', padding: { top: '4%', right: '2%', bottom: '4%', left: '2%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#0f3460', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } }] },
        { id: 'col-2', blocks: [{ id: 'tpl-fit-c3', type: 'text', settings: { content: '<p style="font-size:28px; font-weight:800; color:#e94560; margin:0;">24/7</p><p>Support</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#a7b1c2', textAlign: 'center', lineHeight: '1.4', padding: { top: '4%', right: '2%', bottom: '4%', left: '2%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#0f3460', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '8px' } }] }
      ] } },
      { id: 'tpl-fit-5', type: 'button', settings: { text: 'Start Your Challenge →', link: '#', fontSize: '18px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#ffffff', backgroundColor: '#e94560', textAlign: 'center', padding: { top: '16px', right: '40px', bottom: '16px', left: '40px' }, margin: { top: '3%', right: '0%', bottom: '3%', left: '0%' }, borderWidth: '0px', borderColor: '#0056b3', borderRadius: '30px', width: 'auto' } },
      { id: 'tpl-fit-6', type: 'text', settings: { content: '<p>Early bird price: <strong>$29/month</strong> (regular $49/month)</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#64748b', textAlign: 'center', lineHeight: '1.5', padding: { top: '1%', right: '5%', bottom: '5%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } }
    ]
  },

  // ── Agency Portfolio ──
  {
    id: 'agency',
    name: 'Agency Introduction',
    category: 'Agency',
    description: 'Introduce your agency services and portfolio',
    thumbnail: 'agency',
    subject: 'Let\'s Build Something Great Together',
    blocks: [
      { id: 'tpl-ag-1', type: 'image', settings: { src: '', alt: 'Agency Logo', width: '40%', height: 'auto', link: '', textAlign: 'center', padding: { top: '5%', right: '0%', bottom: '2%', left: '0%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-ag-2', type: 'heading', settings: { content: 'We Design Experiences That Convert', fontSize: '28px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#1e293b', textAlign: 'center', lineHeight: '1.3', padding: { top: '2%', right: '5%', bottom: '1%', left: '5%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-ag-3', type: 'text', settings: { content: '<p>We are a full-service digital agency specializing in web design, branding, and growth marketing. Here is what we can do for you:</p>', fontSize: '15px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569', textAlign: 'center', lineHeight: '1.6', padding: { top: '1%', right: '6%', bottom: '3%', left: '6%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', borderWidth: '0px', borderColor: '#cccccc', borderRadius: '0px' } },
      { id: 'tpl-ag-4', type: 'columns', settings: { columnCount: 2, gap: '3%', padding: { top: '2%', right: '4%', bottom: '2%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent', columns: [
        { id: 'col-0', blocks: [
          { id: 'tpl-ag-c1', type: 'text', settings: { content: '<p><strong>🎨 Web Design</strong></p><p>Custom websites that look stunning and convert visitors into customers.</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569', textAlign: 'left', lineHeight: '1.6', padding: { top: '4%', right: '4%', bottom: '4%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '2%', left: '0%' }, backgroundColor: '#f8fafc', borderWidth: '1px', borderColor: '#e2e8f0', borderRadius: '8px' } },
          { id: 'tpl-ag-c1b', type: 'text', settings: { content: '<p><strong>📈 Growth Marketing</strong></p><p>Data-driven strategies that scale your business and maximize ROI.</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569', textAlign: 'left', lineHeight: '1.6', padding: { top: '4%', right: '4%', bottom: '4%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#f8fafc', borderWidth: '1px', borderColor: '#e2e8f0', borderRadius: '8px' } }
        ] },
        { id: 'col-1', blocks: [
          { id: 'tpl-ag-c2', type: 'text', settings: { content: '<p><strong>💡 Branding</strong></p><p>Build a memorable brand identity that resonates with your audience.</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569', textAlign: 'left', lineHeight: '1.6', padding: { top: '4%', right: '4%', bottom: '4%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '2%', left: '0%' }, backgroundColor: '#f8fafc', borderWidth: '1px', borderColor: '#e2e8f0', borderRadius: '8px' } },
          { id: 'tpl-ag-c2b', type: 'text', settings: { content: '<p><strong>📱 Mobile Apps</strong></p><p>Native and cross-platform apps built for performance and user delight.</p>', fontSize: '14px', fontFamily: 'Arial, sans-serif', fontWeight: 'normal', color: '#475569', textAlign: 'left', lineHeight: '1.6', padding: { top: '4%', right: '4%', bottom: '4%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: '#f8fafc', borderWidth: '1px', borderColor: '#e2e8f0', borderRadius: '8px' } }
        ] }
      ] } },
      { id: 'tpl-ag-5', type: 'button', settings: { text: 'Book a Free Consultation', link: '#', fontSize: '16px', fontFamily: 'Arial, sans-serif', fontWeight: 'bold', color: '#ffffff', backgroundColor: '#6366f1', textAlign: 'center', padding: { top: '14px', right: '32px', bottom: '14px', left: '32px' }, margin: { top: '3%', right: '0%', bottom: '2%', left: '0%' }, borderWidth: '0px', borderColor: '#0056b3', borderRadius: '8px', width: 'auto' } },
      { id: 'tpl-ag-6', type: 'social', settings: { networks: [{ name: 'facebook', url: '#', enabled: true }, { name: 'twitter', url: '#', enabled: true }, { name: 'instagram', url: '#', enabled: true }, { name: 'linkedin', url: '#', enabled: true }, { name: 'youtube', url: '', enabled: false }, { name: 'tiktok', url: '', enabled: false }, { name: 'pinterest', url: '', enabled: false }, { name: 'github', url: '', enabled: false }], iconSize: '28', iconSpacing: '8', iconStyle: 'colored', iconRadius: '50%', textAlign: 'center', padding: { top: '2%', right: '4%', bottom: '4%', left: '4%' }, margin: { top: '0%', right: '0%', bottom: '0%', left: '0%' }, backgroundColor: 'transparent' } }
    ]
  }
]
